import { useCallback } from 'react';
import { useRefGetter } from './useRefGetter';
export function useRefFunction(callback, defaultFunc) {
  var refGetter = useRefGetter(callback);
  var defaultGetter = useRefGetter(defaultFunc);
  return useCallback(function () {
    var fn = refGetter();
    var fnDefault = defaultGetter();
    return fn ? fn.apply(void 0, arguments) : fnDefault.apply(void 0, arguments);
  }, []);
}